<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      transition="dialog-top-transition"
      max-width="550px"
    >
      <v-card>
        <div class="container-comfirm">
          <div class="card-title">
            <h3>ยังไม่ระบุร้านค้าช่วง</h3>
            <small>กรุณาเลือกร้านค้าช่วงเพื่อบันทึกโน๊ต</small>
          </div>
          <div class="card-search">
            <v-autocomplete
              solo
              v-model="value"
              item-text="customer_name"
              item-value="customer_id"
              :items="customer"
              placeholder="เลือกร้าน"
              hide-details
              hide-selected
            />
          </div>
          <div class="d-flex justify-content-between">
            <v-btn class="btn-checklist" @click="$emit('close')">กลับ</v-btn>
            <v-btn class="btn-submit" @click="saveForm()">บันทึก</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ['dialog', 'customerId', 'customerItem'],

  computed: {
    customer() {
      const ctm = this.customerItem
      const ctm_array = []
      ctm.forEach((element) => {
        ctm_array.push({
          customer_name: element.customer_name,
          customer_pic: element.customer_pic,
          customer_id: element.customer_id,
          user_id: element.user_id,
          shop_id: element.shop_id,
        })
      })
      return ctm_array
    },
  },

  data() {
    return {
      value: null,
    }
  },

  watch: {
    dialog(newValue) {
      if (newValue) {
        this.value = this.customerId != '' ? this.customerId : null
      }
    },
  },

  methods: {
    saveForm() {
      if (this.value !== null) {
        this.$emit('save', this.value)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container-comfirm {
  justify-content: center;
  margin: 30px 25px;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.card-title {
  margin: 20px 0px;
}
.card-search {
  margin-bottom: 45px;
}

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 20px !important;
}
</style>
